module.exports = __webpack_public_path__ + "img/Brick.ec51f97e.png";